export default (set) => (props, propName) => {
  const { [propName]: prop } = props;

  if (!Array.isArray(prop) && !typeof prop === 'string') {
    return new Error(`${propName} must be an array or a string`);
  }

  if (typeof prop === 'string' && !set.includes(prop)) {
    return new Error(`${propName} must be one of ${set.join()}`);
  }

  if (Array.isArray(prop) && prop.some((item) => !set.includes(item))) {
    return new Error(`${propName} must be made of one or more of ${set.join()}`);
  }

  return null;
};
